// extracted by mini-css-extract-plugin
export default {"closeFilters":"styles_closeFilters__TRIdS","filters":"styles_filters__MsV7y","opened":"styles_opened__Zn6is","main":"styles_main__ZJVAL","footer":"styles_footer__HPKT9"};